export default __webpack_public_path__ + "static/media/btn_follow.c2a2a0b4.svg";